import { VatFormula } from '@/api';

export const vatModelsSizes: Record<VatFormula, { value: string; text: string }[]> = {
	FonterraVatII: [
		{ value: '2000', text: '2000' },
		{ value: '2300', text: '2300' },
		{ value: '3400', text: '3400' },
		{ value: '4100', text: '4100' },
		{ value: '4500', text: '4500' },
		{ value: '5700', text: '5700' },
		{ value: '6800', text: '6800' },
		{ value: '7800', text: '7800' },
		{ value: '9100', text: '9100' },
		{ value: '11000', text: '11000' },
		{ value: '11500W', text: '11500W' },
		{ value: '12000', text: '12000' },
		{ value: '14000', text: '14000' },
		{ value: '14000W', text: '14000W' },
		{ value: '15000', text: '15000' },
		{ value: '16000', text: '16000' },
		{ value: '16000W', text: '16000W' },
		{ value: '18000', text: '18000' },
		{ value: '18000W', text: '18000W' },
		{ value: '21500W', text: '21500W' },
		{ value: '24500W', text: '24500W' },
		{ value: '26500W', text: '26500W' },
		{ value: '30000W', text: '30000W' },
	],
	Butterfly: [
		{ value: '1050', text: '1050' },
		{ value: '1700', text: '1700' },
		{ value: '2250', text: '2250' },
		{ value: '2700', text: '2700' },
		{ value: '2700Cummings', text: '2700 Cummings' },
		{ value: '3400', text: '3400' },
		{ value: '3400Winiata', text: '3400 Winiata' },
		{ value: '3400KMOrganics', text: '3400 KM Organics' },
		{ value: '3700', text: '3700' },
		{ value: '3700DargavilleOrganics', text: '3700 Dargaville Organics' },
		{ value: '4100', text: '4100' },
		{ value: '4500', text: '4500' },
		{ value: '4500TawaRidge', text: '4500 Tawa Ridge' },
		{ value: '4710MJDFarms', text: '4710 MJD Farms' },
		{ value: '5700', text: '5700' },
		{ value: '6800', text: '6800' },
		{ value: '9100', text: '9100' },
	],
	Longveld: [
		{ value: '5400', text: '5400' },
		{ value: '7500', text: '7500' },
		{ value: '9400', text: '9400' },
		{ value: '11400', text: '11400' },
		{ value: '21000', text: '21000' },
		{ value: '29000', text: '29000' },
	],
	Spherical: [
		{ value: '10000', text: '10000' },
		{ value: '14000', text: '14000' },
		{ value: '24500', text: '24500' },
		{ value: '31000', text: '31000' },
	],
	Crown: [{ value: '22000', text: '22000' }],
};
